import React, { useEffect } from "react";
import FAQS from "../Components/FAQS";
import Hero from "../Components/Hero";
import HowWorks from "../Components/HowWorks";
import WhyUs from "../Components/WhyUs";
import Speciality from "../Components/Speciality";
import Compra from "../Components/Compra";


const Home = () => {
  useEffect(() => {
    const ScrollToTop = () => {
      window.scrollTo(0, 0);
    };
    ScrollToTop();
  }, []);

  return (
    <>
      <Hero />
      <HowWorks />
      <WhyUs />
      <Compra />
      <Speciality />
      <FAQS />
    </>
  );
};

export default Home;
